import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

import { VehiclesDocumentsFiltersComponent } from '../vehicles-documents-filters/vehicles-documents-filters.component';

@Component({
	selector: 'app-vehicles-documents-list',
	templateUrl: './vehicles-documents-list.component.html',
	styleUrls: ['./vehicles-documents-list.component.css'],
})
export class VehiclesDocumentsListComponent implements OnInit {
	loader = true;
	private itemsBeforeDataLoad = 8;
	documentTypeId: Array<any> = [];
	statuses: Array<any> = [];
	vehicle_busTypes: Array<any> = [];
	vehiclesDocuments = [];
	types = [];
	types2 = [];
	busTypes = [];
	confirmed = [];
	filters = {
		documentTypeId: [],
		vehicle_status: [],
		types: [],
	};
	parameters = {
		vehicle_busType: [],
		types: [],
		vehicles: [],
		documentsType: [],
		documentTypeId: [],
		companyName: [],
		statuses: [],
	};
	tableRows = [
		{
			id: 'vehicleName',
			name: 'Pojazd',
		},
		{
			id: 'registration_number',
			name: 'Nr. Rej',
		},
		{
			id: 'document_type',
			name: 'Typ',
		},
		{
			id: 'endDate',
			name: 'Data do',
		},
		{
			id: 'company_name',
			name: 'Licencja',
		},
	];

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		this.api.get('/vehicles/', (result, error) => {
			this.parameters.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/company/', (result, error) => {
			this.parameters.companyName = result.data;
			this.loadData();
		});
		this.api.get('/vehicleDocumentsTypes/', (result, error) => {
			this.parameters.documentsType = result.data;
			this.loadData();
		});
		this.api.get('/vehicleTypes/', (result, error) => {
			this.parameters.types = result.data;
			this.loadData();
		});
		this.api.get('/vehicleTypes2/', (result, error) => {
			this.types2 = result.data;
			this.loadData();
		});
		this.api.get('/vehicleBusTypes/', (result, error) => {
			this.busTypes = result.data;
			this.loadData();
		});
		this.api.get('/vehicleStatuses/', (result, error) => {
			this.parameters.statuses = result.data;
			this.loadData();
		});
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		const parms: string = this.api.getChecked(this.filters, this.parameters);
		this.api.get('/vehicleDocuments/?' + parms, (result, error) => {
			result.data.forEach((obj) => {
				const vehicle = this.parameters.vehicles.find((objFind) => objFind.id == obj.vehicleId);
				obj.vehicleName = vehicle ? vehicle.name : '?';
				obj.registration_number = vehicle ? vehicle.registrationNumber : '?';
				const documents = this.parameters.documentsType.find((objFind) => objFind.id == obj.documentTypeId);
				obj.document_type = documents ? documents.type : '?';
				const company = this.parameters.companyName.find((objFind) => objFind.id == obj.company);
				obj.company_name = company ? company.name : 'Brak';
				obj.id = obj.vehicleId;
			});
			this.vehiclesDocuments = result.data;
			this.loader = false;
		});
	}

	filtersOpen() {
		new VehiclesDocumentsFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}
}
